export default "__VITE_ASSET__DIZ_MDxG__"